import { Model } from './model';

export class DisposizioneCompagniaAllegato extends Model {
  static apiUrl = 'disposizioni-compagnie/allegati';

  nome_originale: string;
  mime?: string;
  dimensione?: number;
  download_url: string;

  deserialize(input: any): DisposizioneCompagniaAllegato {
    let retV: DisposizioneCompagniaAllegato = new DisposizioneCompagniaAllegato();
    retV = super.deserialize(input) as DisposizioneCompagniaAllegato;
    return retV;
  }

  getHumanIdentifier() {
    return this.nome_originale;
  }
}
